import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';

import BrandingContext from '../Context/BrandingContext';
import IconsContext from '../Context/IconsContext';

export default memo(CenterContainer);
function CenterContainer(props) {
  const {
    isBarkoUi,
    isBrandedExperienceUi,
    isCustomerDemoUi,
    isEnovationUi,
    isSupraUi,
    isVersatileUi,
  } = useContext(BrandingContext);
  const { loginBackgroundImage, tigeLoginBackgroundImage } =
    useContext(IconsContext);
  const isTigeDemoUi = window.location.host?.includes('tige');

  const loginUrl = isTigeDemoUi
    ? tigeLoginBackgroundImage
    : loginBackgroundImage;
  const backgroundGradientRgba =
    isEnovationUi || isSupraUi
      ? '0, 0, 0, 0.0'
      : isBarkoUi || isVersatileUi
        ? '204, 0, 0, 0.0'
        : `131, 191, 203, ${
            isBrandedExperienceUi || isCustomerDemoUi || isTigeDemoUi
              ? '0.2'
              : '0.66'
          }`;

  return (
    <div className="center-container min-vh-100 min-wh-100 d-flex flex-wrap justify-content-center align-items-center">
      {props.children}
      <style jsx>{`
        .center-container {
          background:
            linear-gradient(
              rgba(${backgroundGradientRgba}),
              rgba(${backgroundGradientRgba})
            ),
            url(${loginUrl}) no-repeat center center fixed;
          background-size: cover;
        }
      `}</style>
    </div>
  );
}

CenterContainer.propTypes = { children: PropTypes.node };
